<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
              <!-- 左侧竖向步骤条 -->
              <div style="width: 240px; min-width: 240px; margin-right: 24px;">
                <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
                  <el-step v-for="(itemf, index) of activeList"
                          :key="index" :title="itemf.processNodeName" :status="itemf.stepStatus || 'process'">
                    <template slot="description">
                      <div v-if="itemf.processNodeName === '制单人'">
                        {{ itemf.approvalTime }}
                      </div>
                      <div v-else>
                        <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                        <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                        <div>经办人：{{ itemf.maker || '' }}</div>
                        <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                        <div>时间：{{ itemf.makerTime || '' }}</div>
                      </div>
                    </template>
                  </el-step>
                </el-steps>
              </div>
              <!-- 右侧内容 -->
              <div style="flex: 1; overflow-x: auto;">
                <Boyo-Formtwo :formInfo="formInfo"
                        :refObj.sync="formInfo.ref"
                        :listTypeInfo='listTypeInfo'
                        @handlePictureCardPreview="handlePictureCardPreview">
                </Boyo-Formtwo>
                <el-table :data="tableData"
                        border
                        :summary-method="getSummaries"
                        show-summary
                        max-height="430"
                        style="width: 99%;"
                        :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                        :cell-style="{padding:'2px'}">
                        <el-table-column fixed="left"
                        type="index"
                        width="50">
                        </el-table-column>
                    <el-table-column prop="invoiceNo"
                                    align="center"
                                    label="发票代码" width="110">
                    </el-table-column>
                    <el-table-column prop="invoiceCode"
                                    align="center"
                                    label="发票号码" width="110">
                    </el-table-column>
                    <el-table-column prop="digitalTicketNumber"
                                    align="center"
                                    label="数电票号码" width="140">
                    </el-table-column>
                    <el-table-column prop="partnerTaxNo"
                                    align="center"
                                    label="销方识别号" width="140">
                    </el-table-column>
                    <el-table-column prop="partnerName"
                                    align="center"
                                    label="销方名称" width="120">
                    </el-table-column>
                    <el-table-column prop="taxNo"
                                    align="center"
                                    label="购方识别号" width="140">
                    </el-table-column>
                    <el-table-column prop="purchaserName"
                                    align="center"
                                    label="购买方名称" width="130">
                    </el-table-column>
                    <el-table-column prop="invoiceDate"
                                    align="center"
                                    label="开票日期" width="130">
                    </el-table-column>
                    <el-table-column prop="taxCode"
                                    align="center"
                                    label="税收分类编码" width="120">
                    </el-table-column>
                    <el-table-column prop="businessType"
                                    align="center"
                                    label="特定业务类型" width="120">
                    </el-table-column>
                    <el-table-column prop="materialName"
                                    align="center"
                                    label="货物或应税劳务名称" width="100">
                    </el-table-column>
                    <el-table-column prop="materialSpec"
                                    align="center"
                                    label="规格型号" width="100">
                    </el-table-column>
                    <el-table-column prop="purUnit"
                                    align="center"
                                    label="单位" width="80">
                    </el-table-column>
                    <el-table-column prop="purQuantity"
                                    align="center"
                                    label="数量" width="80">
                    </el-table-column>
                    <el-table-column prop="purExctTaxPrice"
                                    align="center"
                                    label="单价" width="80">
                    </el-table-column>
                    <el-table-column prop="invoicePrice"
                                    align="center"
                                    label="金额" width="100">
                    </el-table-column>
                    <el-table-column prop="taxRate"
                                    align="center"
                                    label="税率" width="80">
                    </el-table-column>
                    <el-table-column prop="taxAmount"
                                    align="center"
                                    label="税额" width="100">
                    </el-table-column>
                    <el-table-column prop="taxInclusiveAmount"
                                    align="center"
                                    label="价税合计" width="100">
                    </el-table-column>
                    <el-table-column prop="invoiceSource"
                                    align="center"
                                    label="发票来源" width="120">
                    </el-table-column>
                    <el-table-column prop="image"
                                    align="center"
                                    label="发票文件" width="120">
<template v-slot="scope">
        <a class="el-icon-view" v-if="scope.row.image"
            @click="viewInvoiceFile(scope.row.image)">查看
        </a>
        <span v-else>暂无</span>
    </template>
</el-table-column>
                    <el-table-column prop="invoiceType"
                                    align="center"
                                    label="发票票种" width="120">
                    </el-table-column>
                    <el-table-column prop="invoiceStatusStr"
                                    align="center"
                                    label="发票状态" width="100">
                    </el-table-column>
                    <el-table-column prop="positiveInvoiceStr"
                                    align="center"
                                    label="是否正数发票" width="120">
                    </el-table-column>
                    <el-table-column prop="riskLevel"
                                    align="center"
                                    label="发票风险等级" width="120">
                    </el-table-column>
                    <el-table-column prop="invoiceBy"
                                    align="center"
                                    label="开票人" width="100">
                    </el-table-column>
                    <el-table-column prop="invoiceNote"
                                    align="center"
                                    label="备注" width="100">
                    </el-table-column>
                </el-table>
                
                <!-- 审核表单 -->
                <div v-if="showAuditForm" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                   <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                  <Boyo-Formtwo :formInfo="formInfo2"
                             :refObj.sync="formInfo2.ref"
                             :listTypeInfo="listTypeInfo">
                  </Boyo-Formtwo>
                </div>
              </div>
            </div>
        </Boyo-Dialog>
    </div>
</template>

<script>
import BoyoDialog from '@/components/BoyoDialog'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'InvoiceDetailDialog',
  components: {
    BoyoDialog,
    BoyoFormtwo
  },
  data () {
    return {
      billId: null,
      dataId: null,
      createdBy: null,
      createdTime: null,
      activeValue: 0,
      activeList: [],
      tableData: [],
      pingImgUrl: config.pingImgUrl,
      detailDate: {},
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '发票'
        ],
        showPhraseManager: false,
        newPhrase: '',
      listTypeInfo: {
        processId: [],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}]
      },
      dialogInfoData: {
        visible: false,
        type: 'update',
        title: {
          update: '发票详情'
        },
        width: '90%',
        btList: [
          { label: '审核', type: 'success', icon: '', event: 'save', loading: false, show: false},
          {
            label: '关闭',
            event: 'close',
            show: true
          }
        ]
      },
      // 基础信息表单 重命名为 formInfo
      formInfo: {
        ref: null,
        labelWidth: "100px",
        inline: true,
        data: {
          settleNo: '',
          partnerName: ''
        },
        list: [
          { type: 'text', label: '结算单号：', value: 'settleNo', style: 'width:90%', className: 'form_item_two', disabled: true},
          { type: 'text', label: '供应商：', value: 'partnerName', style: 'width:90%', className: 'form_item_two', disabled: true}
        ],
        rules: {}
      },
      // 审核表单相关（对齐 InternalWeighingDialog.vue）
      auditParm: {},
      showAuditForm: false, // 是否显示审核表单
      formInfo2: {
        ref: null,
        labelWidth: '100px',
        data: {
          id: '',
          processId: '',
          status: 1,
          remark: ''
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%', disabled: true },
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one', list: 'statusFlag2', unclearable: true },
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%' }
        ],
        rules: {
          status: [{ required: true, trigger: 'change', message: '请选择' }]
        }
      }
    }
  },
  mounted () {
    // 加载流程枚举数据
    this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
      if(res.code == 0) {
        let list1 = res.data.list
        for(let i in list1) {
          this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
        }
      }
    })
  },
  methods: {
    dialogShow(data, val, parm, id, maker, makerTime){
        this.billId = data
        this.dataId = id
        // 保存传入的制单人和时间
        this.createdBy = maker
        this.createdTime = makerTime
        
        // 处理审批参数
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
          this.showAuditForm = true
          
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfo2.data) {
              this.formInfo2.data[key] = ''
            }
            
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfo2.data.processId = inde.value
                  processFound = true;
                  break;
                }
              }
              
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                console.warn('未找到匹配的流程ID:', parm.processId, '可用的流程枚举:', this.listTypeInfo.processId);
                // 直接使用processId作为备选
                this.formInfo2.data.processId = parm.processId;
              }
              
              this.formInfo2.data.status = 1
            });
          })
        }else{
          this.dialogInfoData.btList[0].show = false
          this.showAuditForm = false
        }
        
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  let stepStatus = 'process';
                  if (res.data.list[i].status == 1) {
                    stepStatus = 'success';
                  } else if (res.data.list[i].status == 2) {
                    stepStatus = 'error';
                  } else {
                    stepStatus = 'process';
                  }
                  this.activeList.push({
                    processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
                    maker: res.data.list[i].status
                      ? res.data.list[i].actualApprover
                      : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
                    remark: res.data.list[i].remark || '', // 第三行：备注
                    makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
                    stepStatus
                  });
              }
              
              // 始终在最前面插入"制单人"节点
              // 优先使用传入的制单人和时间，如果没有则尝试使用val中的数据
              let maker = this.createdBy || (val && val.createBy ? val.createBy : '暂无');
              let makerTime = this.createdTime || (val && val.createTime ? val.createTime : '');
              let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
              this.activeList.unshift({ processNodeName: '制单人', approvalTime });
              this.activeValue = (this.activeValue || 0) + 1;
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      
      // 获取发票数据
      this.$api.OrderPurchase.getFinPaymentEntryPage({id: this.billId, pageNum: 1, pageSize: 0}).then(res => {
        if (res.code == 0) {
          if (res.data.list.length > 0) {
            this.tableData = res.data.list
            // 获取结算单信息
            this.$api.OrderPurchase.getPurArrivalSettleNoPage({ 
              ShipStatus: 5,
              settleNo: res.data.list[0].settleNo,
              pageNum: 1,
              pageSize: 0 
            }).then(res => {
              if (res.code == 0 && res.data.list.length > 0) {
                this.detailDate = res.data.list[0]
                // 填充表单数据
                for (let key in this.detailDate) {
                  if (key in this.formInfo.data) {
                    this.formInfo.data[key] = this.detailDate[key];
                  }
                }
                this.dialogInfoData.visible = true
              } else {
                this.$message({ message: res.msg || '获取结算单信息失败', type: "error" });
              }
            })
          } else {
            this.$message({ message: '对应数据查找为空', type: 'warning' })
          }
        } else {
          this.$message({ message: res.msg, type: "error" });
        }
      }).catch(err => {
        console.log(err)
        this.$message({ message: '获取发票数据失败', type: "error" });
      })
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              this.formInfo2.ref.validate(valid => {
                if (valid) {
                  let parma = {
                    id: this.auditParm.id,
                    processId: this.formInfo2.data.processId,
                    status: this.formInfo2.data.status,
                    remark: this.formInfo2.data.remark
                  }
                  dialogInfoData.btList[0].loading = true
                  this.$api.system.approval(parma).then(res => {
                    dialogInfoData.btList[0].loading = false
                    if (res.code === 0) {
                      this.$message({ message: res.msg, type: 'success' })
                      dialogInfoData.visible = false
                      this.showAuditForm = false
                      this.$emit('approvalInfo')
                    } else {
                      this.$message({ message: res.msg, type: 'error' })
                    }
                  }).catch(() => {
                    dialogInfoData.btList[0].loading = false
                  })
                }
              })
              break
            case 'close':
                dialogInfoData.visible = false
                this.showAuditForm = false
                break
            case 'opened':
                // 弹窗打开时的处理
                break
        }
    },
    handlePictureCardPreview(url) {
      if(url){
        window.open(this.pingImgUrl + url)
      }
    },
        viewInvoiceFile(fileUrl) {
        if (fileUrl) {
            // 如果已经是完整URL，直接打开
            if (fileUrl.startsWith('http')) {
                window.open(fileUrl);
            } else {
                // 否则拼接基础URL
                window.open(this.pingImgUrl + fileUrl);
            }
        }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.formatAmount(sums[index]);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>

<style lang="stylus" scoped>
.custom-steps-vertical
  .el-step__description
    padding-left 10px

.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/InvoiceDetailDialog.vue